import { useVehicleCount } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { useListType } from 'Stores/ListStore/ListStore';
import { LIST_TYPES } from 'Utilities/consts';
import useSaleTimes from 'Utilities/hooks/useSaleTimes';

interface UseVehicleListRefreshState {
	shouldPromptVehicleListRefresh: boolean;
	shouldVehicleListRefresh: boolean;
}

const useVehicleListRefreshState = (): UseVehicleListRefreshState => {
	const { isSaleActive } = useSaleTimes();
	const listType = useListType();
	const vehicleCount = useVehicleCount();

	// TODO May not be needed after next sale preview feature toggle is removed
	const shouldPromptVehicleListRefresh = !isSaleActive && listType === null && vehicleCount > 0;
	const shouldVehicleListRefresh =
		!shouldPromptVehicleListRefresh && !isSaleActive && [LIST_TYPES.auction, null].some((val) => val === listType);

	return { shouldPromptVehicleListRefresh, shouldVehicleListRefresh };
};

export default useVehicleListRefreshState;
